
export default function Services() {
  const services = [
    {
      icon: 'ri-car-washing-line',
      title: 'Exterior Detailing',
      description: 'Complete exterior wash, clay bar treatment, paint correction, and premium wax protection for a showroom shine.',
      price: 'From $80'
    },
    {
      icon: 'ri-steering-2-line',
      title: 'Interior Detailing',
      description: 'Deep cleaning of carpets, dashboard, and all interior surfaces. Leather conditioning and odor elimination included.',
      price: 'From $70'
    },
    {
      icon: 'ri-contrast-drop-2-line',
      title: 'Paint Protection',
      description: 'Ceramic coating and paint sealant application to protect your vehicle from environmental damage and UV rays.',
      price: 'From $150'
    },
    {
      icon: 'ri-sparkling-2-line',
      title: 'Full Detail Package',
      description: 'Complete interior and exterior detailing service. Includes everything your car needs to look and feel brand new.',
      price: 'From $200'
    },
    {
      icon: 'ri-car-line',
      title: 'Engine Bay Cleaning',
      description: 'Thorough cleaning and degreasing of your engine compartment, making it look as good as the rest of your vehicle.',
      price: 'From $60'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">Our Services</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Professional auto detailing services tailored to keep your vehicle looking its absolute best
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-green-700 to-green-600 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-yellow-400`}></i>
              </div>
              <h3 className="text-2xl font-bold mb-3 text-gray-900">{service.title}</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
              <div className="text-2xl font-bold text-green-700">{service.price}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
